var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 8C2.66675 9.41449 3.22865 10.771 4.22885 11.7712C5.22904 12.7714 6.58559 13.3333 8.00008 13.3333C9.41457 13.3333 10.7711 12.7714 11.7713 11.7712C12.7715 10.771 13.3334 9.41449 13.3334 8",
    stroke: "#F8F8F8",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33341V2.66675M8 2.66675L10 4.66675M8 2.66675L6 4.66675",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.ff58872acdb68f2b36e27439f84d2193.svg";
export { ForwardRef as ReactComponent };